import { getDevice } from "../device";
import { dmnStorage } from "../dmnStorage";

const storageKey = "featureFlags";

type FeatureFlagsDataStorageType = {
  key: string;
  title: string;
  description?: string;
  isEnabled: boolean;
};

const defaultFeatureFlags: FeatureFlagsDataStorageType[] = [
  {
    key: "showUnsyncedTab",
    title: "Unsynced tab",
    description:
      "Show the unsynced tab when bookings aren't sent to the server straight away",
    isEnabled: true
  },
  {
    key: "showLastSyncDate",
    title: "Show last sync",
    description: "Display the last sync date under the user name",
    isEnabled: false
  },
  {
    key: "showPrint",
    title: "Show print option",
    description: "Display print option",
    isEnabled: false
  },
  {
    key: "showSiteInformation",
    title: "Show site information",
    description: "Display site information",
    isEnabled: false
  },
  {
    key: "enableInvoicing",
    title: "Enable Invoicing",
    description: "Show the Invoices section on the booking payments tab",
    isEnabled: false
  },
  {
    key: "showAICoPilot",
    title: "AI Assistant",
    description:
      "Enable AI-powered insights and explanations in Space Optimiser (requires Evo tier)",
    isEnabled: false
  },
  {
    key: "alphaHeader",
    title: "Alpha header",
    description:
      "Preview the redesigned header: venue grouped with context, search in its own slot, utilities collapsed to an overflow menu",
    isEnabled: getDevice() === "mobile"
  }
];

export const addFeatureFlagsStorage = async (
  data: FeatureFlagsDataStorageType[]
) => {
  if (data.length === 0) {
    return;
  }
  return await dmnStorage.add(storageKey, data);
};

export const getFeatureFlagsStorage = async (): Promise<
  FeatureFlagsDataStorageType[]
> => {
  const response: FeatureFlagsDataStorageType[] | undefined =
    await dmnStorage.get(storageKey);

  try {
    const flagsWithDefaults = defaultFeatureFlags.map((defaultFlag) => ({
      ...defaultFlag,
      isEnabled:
        response?.find((storedFlag) => storedFlag.key === defaultFlag.key)
          ?.isEnabled ?? defaultFlag.isEnabled
    }));

    return flagsWithDefaults;
  } catch (e) {
    console.error("Error parsing feature flags from storage:", e);
    return [];
  }
};
